module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAKlBMVEUAAAAiZpkiZpkiZpkiZpkiZpkiZpkiZplklLfb5u71+Povb5/N3eiMr8otXGazAAAACHRSTlMAYL//ACDP71kzCuAAAADWSURBVHgB7dbRCcJADIfxzKATiBNoHiz09XQCcQKdwBH6VpzgJuj9wT2cwWmUEmoL5hJBfbrvIU8/VCIcIaIZZ1uEQOHARqdA27OFNnvasdmR5jZa0dJGa+JxVURfanjcFLWQugyKkJKOagxl0Y2fXXKIgf4XVwaST3Qg/iWSTTNjEvOweZJNv0foRihqKL1QDQ3hQ8QFFVRQQd6nx/eI2c+h3f/RHdmuPYKRH7m+Tv4kdQqKQNKnoBbo9CmoiqnR5zc37jpoXKeR68hynWu+wy8E+4R8ANkv76d1xTDhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f6c4.png
// module id = 1310
// module chunks = 0